import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useSelector, useDispatch } from "react-redux";
import { Button, Checkbox, Image } from "antd";
import axios from "axios";
import Medication from "../assets/medication.png";
import Progress from "./Progress";
import { trackEvent } from "../helpers/analytics";
import config from "../config";

const Addon = (props) => {
  const { addon } = useSelector((state) => state);
  const dispatch = useDispatch();
  const { wanted, consent } = addon;
  const [addonPrice, setAddonPrice] = useState(0);

  useEffect(() => {
    document.title = "Symptom Relief Add-on - UTIRX";
    trackEvent("step_view", "Symptom Relief Add-on", 3);
    (async () => {
      const { data } = await axios.get(`${config.baseUrl}settings/price`);
      setAddonPrice(data.addonPrice || 0);
    })();
  }, []);

  const setWanted = (value) => {
    dispatch({
      type: "SET_ADDON",
      // Selecting "No" clears any prior consent.
      addon: { wanted: value, consent: value ? consent : false },
    });
  };

  const setConsent = (checked) => {
    dispatch({ type: "SET_ADDON", addon: { ...addon, consent: checked } });
  };

  // Must pick an option; if adding the medication, the consent box is required.
  const canContinue = wanted === false || (wanted === true && consent);

  const handleContinue = () => {
    if (!canContinue) return;
    props.incrementStep();
  };

  const optionStyle = (selected) => ({
    display: "block",
    width: "100%",
    padding: "12px 22px",
    marginBottom: "16px",
    fontSize: "20px",
    textAlign: "left",
    borderRadius: "6px",
    border: `1px solid ${selected ? "#1E9BD7" : "#cfe0ee"}`,
    backgroundColor: selected ? "#1E9BD7" : "#fff",
    color: selected ? "#fff" : "#4b5563",
    cursor: "pointer",
    transition: "all 0.15s ease",
  });

  return (
    <div
      className="flex column question-container"
      style={{ overflowY: "auto", paddingBottom: "32px" }}
    >
      <div className="responsive">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            alignItems: "center",
          }}
        >
          {props.index !== 0 && (
            <>
              <p
                onClick={() => {
                  props.decrementStep();
                }}
                className="link-button"
              >
                Previous
              </p>
              <p onClick={props.resetQuestion} className="link-button">
                Restart
              </p>
            </>
          )}
        </div>
      </div>
      <div style={{ marginTop: props.index === 0 ? "30px" : "0px" }}>
        {" "}
        <Progress current={props.index} total={props.total} />
      </div>

      <div
        className="flex responsive"
        style={{ justifyContent: "space-between", alignItems: "flex-start" }}
      >
        <div className="interview">
          <Image src={Medication} preview={false} width={"90%"} />
        </div>

        <div
          className="flex column question"
          style={{ marginTop: "72px", width: "100%" }}
        >
          <span
            style={{
              color: "#0064A9",
              fontSize: "12px",
              fontWeight: 700,
              letterSpacing: "0.02em",
            }}
          >
            Optional Symptom Relief Medication
          </span>
          <p>In addition to antibiotics, would you also like a medication for immediate relief of burning and frequent urination?</p>

          <div style={{ marginTop: "20px", maxWidth: "560px" }}>
            <button
              type="button"
              aria-pressed={wanted === true}
              onClick={() => setWanted(true)}
              style={optionStyle(wanted === true)}
            >
              Yes
            </button>
            <button
              type="button"
              aria-pressed={wanted === false}
              onClick={() => setWanted(false)}
              style={optionStyle(wanted === false)}
            >
              No
            </button>

            {wanted === true && (
              <>
                <div
                  style={{
                    marginTop: "8px",
                    padding: "16px 20px",
                    backgroundColor: "#f4f6f9",
                    borderRadius: "8px",
                    fontSize: "13px",
                    color: "#4b5563",
                    lineHeight: 1.5,
                  }}
                >
                  {`Antibiotics usually take a few days to start working. In the meantime, we can prescribe an additional medication (phenazopyridine) which can immediately reduce the symptoms of pain and burning. Would you like to add this prescription to your cart for an additional $${addonPrice}?`}
                </div>

                <Checkbox
                  checked={consent}
                  onChange={(e) => setConsent(e.target.checked)}
                  style={{ marginTop: "20px", alignItems: "flex-start" }}
                >
                  <span
                    style={{
                      fontSize: "13px",
                      color: "#1f2937",
                      lineHeight: 1.5,
                      display: "inline-block",
                    }}
                  >
                    {`I understand that the extra $${addonPrice} fee covers the prescription service only and that I may have additional pharmacy charges if my insurance does not cover the medication.`}
                  </span>
                </Checkbox>
              </>
            )}
          </div>

          <div style={{ marginTop: "24px" }}>
            <Button
              type="primary"
              onClick={handleContinue}
              disabled={!canContinue}
              style={{ backgroundColor: "#0064A9", minWidth: "110px" }}
            >
              Continue
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

Addon.propTypes = {
  incrementStep: PropTypes.func.isRequired,
  decrementStep: PropTypes.func,
  resetQuestion: PropTypes.func,
  index: PropTypes.number,
  total: PropTypes.number,
};

export default Addon;
